//* ຮູບແບບໄຟລ໌ນຳເຂົ້າສິນຄ້າ — ໃຊ້ຮ່ວມກັນທັງ "ຮູບແບບຕົວຢ່າງ Excel" ແລະ ຕົວອ່ານໄຟລ໌ ບໍ່ໃຫ້ສອງບ່ອນຫ່າງກັນ

export const MAX_IMPORT_ROWS = 1000;
export const MAX_EXTRA_IMAGES = 9;
export const CURRENCIES = ["ກີບ", "ບາດ", "ໂດລາ"];

export const EXCEL_COLUMNS = [
  { key: "name", header: "ຊື່ສິນຄ້າ", required: true, width: 28 },
  { key: "cfMessage", header: "ລະຫັດ CF", width: 12 },
  { key: "category", header: "ປະເພດ", width: 16 },
  { key: "brand", header: "ແບຣນ", width: 14 },
  { key: "unit", header: "ຫົວຫນວ່ຍ", aliases: ["ຫົວຫນ່ວຍ"], required: true, width: 11 },
  { key: "amount", header: "ຈໍານວນ", required: true, width: 10 },
  { key: "originPrice", header: "ລາຄາຕົ້ນທືນ", aliases: ["ລາຄາຕົ້ນທຶນ"], width: 13 },
  { key: "price", header: "ລາຄາຂາຍ", required: true, width: 13 },
  { key: "currency", header: "ສະກຸນເງິນ", required: true, width: 11 },
  { key: "coverImageUrl", header: "ຮູບຫນ້າປົກ (URL)", aliases: ["ຮູບປົກ"], width: 34 },
  { key: "imageUrls", header: "ຮູບປະກອບ (URL ຂັ້ນດ້ວຍ ,)", width: 46 },
  { key: "description", header: "ລາຍລະອຽດສິນຄ້າ", aliases: ["ລາຍລອຽດສິນຄ້າ", "ລາຍລະອຽດ"], width: 36 },
];

export const EXCEL_SAMPLE_ROWS = [
  ["ຊຸດນອນ", "ນ12", "ເສື້ອຜ້າ", "CAYLA", "ຜືນ", 1, 29000, 59000, "ກີບ", "https://example.com/cover-1.jpg", "https://example.com/a.jpg,https://example.com/b.jpg", "ຜ້າຝ້າຍ ໃສ່ສະບາຍ"],
  ["ເສື້ອກັນໜາວ", "ນ13", "ເສື້ອຜ້າ", "", "ຜືນ", 3, 15000, 45000, "ກີບ", "https://example.com/cover-2.jpg", "", ""],
  ["ກະເປົາ", "ນ17", "ກະເປົາ", "", "ໂຕ", 2, 8, 29, "ບາດ", "", "", "ໜັງແທ້"],
  ["ເກີບ", "", "", "", "ຄູ່", 1, "", 535, "ບາດ", "", "", ""],
];

//* ຫົວຄໍລຳທີ່ພິມຕ່າງກັນເລັກນ້ອຍ (ໜ/ຫນ, ຳ/ໍາ, ຊ່ອງວ່າງ, ຄຳອະທິບາຍໃນວົງເລັບ) ຖືວ່າອັນດຽວກັນ
export const normalizeHeader = (value) =>
  String(value ?? "")
    .replace(/\(.*?\)/g, "")
    .replace(/\s+/g, "")
    .replace(/ໜ/g, "ຫນ")
    .replace(/ຳ/g, "ໍາ")
    .toLowerCase();

const COLUMN_BY_HEADER = new Map(
  EXCEL_COLUMNS.flatMap((column) =>
    [column.header, ...(column.aliases || [])].map((name) => [normalizeHeader(name), column]),
  ),
);

//* ຄໍລຳປະເພດຍ່ອຍ ເປີດສະເພາະຮ້ານ Vanessa ຈຶ່ງບໍ່ຢູ່ໃນ EXCEL_COLUMNS
export const SUB_CATEGORY_COLUMN = { key: "subCategory", header: "ປະເພດຍ່ອຍ", width: 16 };
export const SUB_CATEGORY_SAMPLE = "ເສື້ອຍືດ";

const text = (value) => (value === undefined || value === null ? "" : String(value).trim());
const normalizeValue = (value) => text(value).replace(/\s+/g, " ").toLowerCase();

export const MAX_OPTIONS_PER_ROW = 2;
const OPTION_HEADER_PREFIX = "Option: ";

/**
 * ຄໍລຳ option ຕາມລາຍການຂອງຮ້ານ. ຊື່ທີ່ຕ່າງກັນແຕ່ຊ່ອງວ່າງ/ໂຕພິມ/ການສະກົດ (" ເບີ"/"ເບີ", Size/size)
 * ລວມເປັນຄໍລຳດຽວ — backend (importExcel.js) ຫາຄ່າດ້ວຍກົດດຽວກັນ
 */
export const buildOptionColumns = (optionValues) => {
  const columns = new Map();
  (optionValues || []).forEach((option) => {
    const name = text(option?.name);
    const value = text(option?.value);
    const key = normalizeHeader(name);
    if (!key || !value) return;
    if (!columns.has(key)) {
      columns.set(key, {
        key: `option:${key}`,
        optionName: name,
        //* ຊື່ຕົງກັບຄໍລຳຫຼັກ ເຊັ່ນ option ຊື່ "ປະເພດ" — ເຕີມຄຳນຳໜ້າ ບໍ່ໃຫ້ອ່ານສັບກັນ
        header: COLUMN_BY_HEADER.has(key) || key === normalizeHeader(SUB_CATEGORY_COLUMN.header)
          ? `${OPTION_HEADER_PREFIX}${name}`
          : name,
        width: Math.max(12, name.length + 4),
        values: [],
        seen: new Set(),
      });
    }
    const column = columns.get(key);
    const seenKey = normalizeValue(value);
    if (!column.seen.has(seenKey)) {
      column.seen.add(seenKey);
      column.values.push(value);
    }
  });
  return [...columns.values()];
};

//* "," ໃນຄ່າເງິນ (1,000) ຕ້ອງເອົາອອກກ່ອນແປງ; ຫວ່າງ = ບໍ່ໄດ້ປ້ອນ
export const toNumber = (value) => {
  const raw = text(value).replace(/,/g, "");
  if (raw === "") return null;
  const number = Number(raw);
  return Number.isFinite(number) ? number : NaN;
};

//* ຕັດສະເພາະ "," ທີ່ຕາມດ້ວຍລິ້ງໃໝ່ — ລິ້ງຮູບບາງເວັບມີ "," ໃນຕົວ (ເຊັ່ນ static.nike.com/.../c_scale,w_1.0/...)
export const splitImageUrls = (value) =>
  text(value)
    .split(/,(?=\s*https?:\/\/)|\n/i)
    .map((url) => url.trim().replace(/,+$/, ""))
    .filter(Boolean);

/**
 * ອ່ານຕາຕະລາງ (header: 1 ຂອງ sheet_to_json) ຕາມ "ຊື່ຫົວຄໍລຳ" ບໍ່ແມ່ນຕຳແໜ່ງ —
 * ໄຟລ໌ຮູບແບບເກົ່າ ແລະ ໄຟລ໌ຈາກ export ເພື່ອແກ້ໄຂ ຈຶ່ງຍັງນຳເຂົ້າໄດ້
 *
 * @returns {{ error?: string, rows?: Array, ignoredColumns?: string[] }}
 *          ignoredColumns = ຄໍລຳທີ່ລະບົບບໍ່ຮູ້ຈັກ ຕ້ອງແຈ້ງຜູ້ໃຊ້ ບໍ່ໃຫ້ຂໍ້ມູນຫາຍງຽບໆ
 */
export const parseSheetRows = (sheetRows, optionColumns = [], { allowSubCategory = false } = {}) => {
  const [headerRow, ...dataRows] = sheetRows || [];
  const indexByKey = {};
  const ignoredColumns = [];
  const optionByHeader = new Map();
  optionColumns.forEach((column) => {
    optionByHeader.set(normalizeHeader(column.header), column);
  });
  if (allowSubCategory) optionByHeader.set(normalizeHeader(SUB_CATEGORY_COLUMN.header), SUB_CATEGORY_COLUMN);
  (headerRow || []).forEach((cell, index) => {
    if (text(cell) === "") return;
    const normalized = normalizeHeader(cell);
    const column = COLUMN_BY_HEADER.get(normalized) || optionByHeader.get(normalized);
    if (!column) ignoredColumns.push(text(cell));
    else if (indexByKey[column.key] === undefined) indexByKey[column.key] = index;
  });

  const missing = EXCEL_COLUMNS.filter((c) => c.required && indexByKey[c.key] === undefined);
  if (missing.length > 0) {
    return { error: `ໄຟລ໌ບໍ່ມີຄໍລຳ: ${missing.map((c) => c.header).join(", ")}` };
  }

  const cell = (row, key) => (indexByKey[key] === undefined ? "" : row[indexByKey[key]]);
  const rows = dataRows
    .filter((row) => (row || []).some((value) => text(value) !== ""))
    .map((row, index) => ({
      id: String(index),
      name: text(cell(row, "name")),
      cfMessage: text(cell(row, "cfMessage")),
      category: text(cell(row, "category")),
      subCategory: text(cell(row, "subCategory")),
      brand: text(cell(row, "brand")),
      unit: text(cell(row, "unit")),
      amount: text(cell(row, "amount")),
      originPrice: text(cell(row, "originPrice")),
      price: text(cell(row, "price")),
      currency: text(cell(row, "currency")),
      coverImageUrl: text(cell(row, "coverImageUrl")),
      imageUrls: text(cell(row, "imageUrls")),
      description: text(cell(row, "description")),
      options: optionColumns.reduce((options, column) => {
        const value = text(cell(row, column.key));
        return value ? { ...options, [column.key]: value } : options;
      }, {}),
    }));

  if (rows.length > MAX_IMPORT_ROWS) {
    return { error: `ນຳເຂົ້າໄດ້ບໍ່ເກີນ ${MAX_IMPORT_ROWS} ແຖວຕໍ່ໄຟລ໌ (ໄຟລ໌ນີ້ມີ ${rows.length} ແຖວ)` };
  }
  return { rows, ignoredColumns };
};

const isHttpUrl = (url) => /^https?:\/\/\S+$/i.test(url);

//* ກວດກ່ອນສົ່ງ — backend ກວດຊ້ຳອີກຊັ້ນ. duplicates ຄື ລະຫັດ CF ທີ່ຊ້ຳກັນເອງໃນໄຟລ໌
export const validateRow = (row, duplicates = new Set(), optionColumns = []) => {
  const errors = [];
  if (text(row.subCategory) && !text(row.category)) errors.push("ປະເພດຍ່ອຍຕ້ອງມີປະເພດຫຼັກ");
  const filledOptions = optionColumns.filter((column) => text(row.options?.[column.key]));
  if (filledOptions.length > MAX_OPTIONS_PER_ROW) {
    errors.push(`ເລືອກ option ໄດ້ບໍ່ເກີນ ${MAX_OPTIONS_PER_ROW} ຢ່າງຕໍ່ແຖວ`);
  }
  filledOptions.forEach((column) => {
    const value = normalizeValue(row.options[column.key]);
    if (!column.values.some((allowed) => normalizeValue(allowed) === value)) {
      errors.push(`ບໍ່ມີ "${text(row.options[column.key])}" ໃນ ${column.optionName} ຂອງຮ້ານ`);
    }
  });
  if (!text(row.name)) errors.push("ກະລຸນາປ້ອນຊື່ສິນຄ້າ");
  if (!text(row.unit)) errors.push("ກະລຸນາປ້ອນຫົວໜ່ວຍ");
  const amount = toNumber(row.amount);
  if (!(amount > 0)) errors.push("ຈຳນວນຕ້ອງຫຼາຍກວ່າ 0");
  const price = toNumber(row.price);
  if (!(price > 0)) errors.push("ລາຄາຂາຍຕ້ອງຫຼາຍກວ່າ 0");
  const originPrice = toNumber(row.originPrice);
  if (originPrice !== null && !(originPrice >= 0)) errors.push("ລາຄາຕົ້ນທຶນບໍ່ຖືກຕ້ອງ");
  if (!CURRENCIES.includes(text(row.currency))) errors.push("ສະກຸນເງິນຕ້ອງເປັນ ກີບ, ບາດ ຫຼື ໂດລາ");
  const extraImages = splitImageUrls(row.imageUrls);
  if (extraImages.length > MAX_EXTRA_IMAGES) errors.push(`ຮູບປະກອບໄດ້ບໍ່ເກີນ ${MAX_EXTRA_IMAGES} ຮູບ`);
  if ([text(row.coverImageUrl), ...extraImages].some((url) => url && !isHttpUrl(url))) {
    errors.push("ລິ້ງຮູບຕ້ອງຂຶ້ນຕົ້ນດ້ວຍ http:// ຫຼື https://");
  }
  if (text(row.cfMessage) && duplicates.has(text(row.cfMessage))) {
    errors.push("ລະຫັດ CF ຊ້ຳກັນໃນໄຟລ໌");
  }
  return errors;
};

export const findDuplicateCodes = (rows) => {
  const seen = new Set();
  const duplicates = new Set();
  rows.forEach((row) => {
    const code = text(row.cfMessage);
    if (!code) return;
    if (seen.has(code)) duplicates.add(code);
    seen.add(code);
  });
  return duplicates;
};

export const toImportInput = (row, ignoreImageErrors = false, optionColumns = []) => ({
  rowKey: row.id,
  options: optionColumns
    .filter((column) => text(row.options?.[column.key]))
    .map((column) => ({ name: column.optionName, value: text(row.options[column.key]) })),
  name: text(row.name),
  cfMessage: text(row.cfMessage),
  category: text(row.category),
  subCategory: text(row.subCategory),
  brand: text(row.brand),
  unit: text(row.unit),
  amount: toNumber(row.amount),
  originPrice: toNumber(row.originPrice) ?? 0,
  price: toNumber(row.price),
  currency: text(row.currency),
  coverImageUrl: text(row.coverImageUrl),
  imageUrls: splitImageUrls(row.imageUrls),
  description: text(row.description),
  ignoreImageErrors,
});

export const IMAGE_FAILURE_LABELS = {
  INVALID_URL: "ລິ້ງບໍ່ຖືກຕ້ອງ",
  BLOCKED_ADDRESS: "ລິ້ງນີ້ບໍ່ອະນຸຍາດ",
  NOT_FOUND: "ບໍ່ພົບຮູບ",
  TOO_LARGE: "ຮູບໃຫຍ່ເກີນ 10MB",
  NOT_IMAGE: "ລິ້ງນີ້ບໍ່ແມ່ນໄຟລ໌ຮູບ JPG, PNG ຫຼື WebP",
  TIMEOUT: "ໂຫຼດຮູບນານເກີນໄປ",
  DOWNLOAD_FAILED: "ໂຫຼດຮູບບໍ່ສຳເລັດ",
};

export const describeImportResult = (result) => {
  switch (result?.status) {
    case "DUPLICATE_CF":
      return "ລະຫັດ CF ນີ້ມີຢູ່ໃນຮ້ານແລ້ວ";
    case "OPTION_NOT_FOUND":
      return `ບໍ່ພົບ option ໃນຮ້ານ: ${result.message || ""}`;
    case "INVALID":
      return "ຂໍ້ມູນແຖວນີ້ບໍ່ຖືກຕ້ອງ";
    case "IMAGE_FAILED":
      return (result.failedImages || [])
        .map((image) => `${IMAGE_FAILURE_LABELS[image.reason] || image.reason}: ${image.url}`)
        .join(" • ");
    default:
      return "ບັນທຶກບໍ່ສຳເລັດ ກະລຸນາລອງໃໝ່";
  }
};
